module.exports = __webpack_public_path__ + "img/horizontal_7_2_7016.bafe6901.png";